import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import setting from '../../setting'
import FDA from '../../components/FDA/FDA'
import { exportarArchivos } from '../../actions/FDA/FDA'
import { getFormValues } from 'redux-form'

export function mapStateToProps (state) {
  return {
    ...state.FDA
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      exportarArchivos,
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FDA))